/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    ApiParameter,
    get,
    post,
    ServiceResult
} from "@insite/client-framework/Services/ApiService";

export const preferenceCenterUserSubscriberListUrl = "/api/preferencecenter";


export interface UserSubscriberList extends ApiParameter {
    subscriberKeyQuery?: string
}
export interface UserSubscriberModel {
    Changed?: boolean;
    Active?: boolean;
    ListName?: string;
    ListId?: string;
}
export interface UserSubscriberListModel extends ApiParameter {
    subscriptions: UserSubscriberModel[];
    subscriberKey?: string;
}

export interface UserSubscriberResponse extends ApiParameter {
    statusCode?: number
}
export async function getUserSubscriberList(parameter: UserSubscriberList) {
    try {
        const getUserSubscriberListModel = await get<UserSubscriberListModel>(`${preferenceCenterUserSubscriberListUrl}/getusersubscriberlist`, parameter);
        return {
            result: getUserSubscriberListModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: ((error as any)?.errorJson?.description),
        };
    }
}

export async function setUserSubscriberList(parameter: UserSubscriberListModel): Promise<ServiceResult<UserSubscriberResponse>> {
    try {
        const setUserSubscriberListModel = await post<UserSubscriberResponse>(`${preferenceCenterUserSubscriberListUrl}/setusersubscriberlist?subscriberKeyQuery=${parameter.subscriberKey}`, parameter);
        return {
            result: setUserSubscriberListModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: ((error as any)?.errorJson?.description),
        };
    }
}
